import React, { Component } from 'react';

import './publications-year-filter.css';

import Rect from '@components/rect';
import YearFilter from '@components/year-filter';

export interface DispatchProps {
    fetchPublicationYears(themeSlug?: string): void;
}

export interface StateProps {
    years: {
        list: number[];
        themeSlug?: string;
    };
    isLoadingYears: boolean;
}

interface ComponentProps {
    size?: 's' | 'l';
    themeSlug?: string;
    selectedYear: string;
    onYearChange: any;
}

type Props = ComponentProps & StateProps & DispatchProps;

export default class PublicationsYearFilter extends Component<Props> {
    public componentDidMount() {
        const { years, themeSlug, fetchPublicationYears } = this.props;

        if (!years.list.length || themeSlug !== years.themeSlug) {
            fetchPublicationYears(themeSlug);
        }
    }

    public render() {
        const { isLoadingYears, years, selectedYear, onYearChange, size = 's' } = this.props;
        let stubWidth: string | number = 200;
        let stubHeight = 30;

        if (size === 'l') {
            stubWidth = '100%';
            stubHeight = 48;
        }

        if (isLoadingYears) {
            return <Rect width={stubWidth} height={stubHeight} />;
        }

        if (!years.list.length) {
            return null;
        }

        return (
            <YearFilter
                size={size}
                years={years.list}
                selectedYear={selectedYear}
                onYearChange={onYearChange}
            />
        );
    }
}
